import { _ } from 'controls';
import { PersonIdentity } from 'src/webid/4.0/model/features';

export class RequestSummaryFeatures {
    @_ personIdentity: PersonIdentity = new PersonIdentity();
    asString: () => string;
}
